import { useCallback } from 'react'

import { SinglePreview } from '../../../../preview/SinglePreview'
import { TabValues } from '../../../../typings'
import { useController } from '../../hooks/useController'

export function Body() {
  const {
    data: { tab, extOrderStep, getRecurrentOrder },
    updateData,
  } = useController()

  const setTab = useCallback(
    (value: TabValues) => {
      updateData({ tab: value })
    },
    [updateData],
  )

  if (!extOrderStep) return null

  return (
    <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
      <SinglePreview
        tab={tab}
        setTab={setTab}
        extOrder={extOrderStep}
        selection={[]}
        getRecurrentOrder={getRecurrentOrder}
        showHeader={false}
      />
    </div>
  )
}
